<template>
    <div>
        <el-dialog :visible.sync="dialogOpenStatus" :class="$style.staffPriceAdj" title="是否指定美容師" top="0" append-to-body
            :destroy-on-close="true" :before-close="closeBtn">
            <div :class="$style['staffPriceAdj__uText']">
                <p>此預約是否為客戶指定的美容師 <strong>{{ createOrderExtraData.name }}？</strong></p>
                <p>此回覆會影響預約收費方金額</p>
            </div>

            <div :class="$style['staffPriceAdj__btnGroup']">
                <el-button class="is-round" type="primary" @click="staffPriceAdjustmentFunc(true)">是</el-button>
                <el-button class="is-round" @click="staffPriceAdjustmentFunc(false)">否</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'StaffPriceAdjustment',
    components: {},
    mixins: [],
    props: {
        /**
         * @description 視窗開啟狀態
         */
        dialogOpenStatus: {
            type: Boolean,
            required: true,
            default: false
        },
        /**
         * @description 按下空白後，會員的資料
         */
        createOrderExtraData: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {};
    },
    provide() { },
    inject: [],
    computed: {},
    watch: {
    },
    created() { },
    mounted() {
     },
    methods: {
        closeBtn(done) {
            this.$emit('closeSelfStaffPriceAdjustment')
            done()
        },
        /**
         * @description 看是否要變價
         */
        staffPriceAdjustmentFunc(status) {
            this.$emit('adjust', status)
        }
    },
};
</script>

<style lang="scss" module>
.staffPriceAdj {
    :global {
        .el-dialog__title {
            font-size: 20px;
        }
    }

    &__uText {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        p {
            font-size: 14px;
            margin-top: 0;
            margin-bottom: 26px;

            &:nth-child(1) {
                margin-bottom: 0;
            }
        }
        strong {
            color: $color-primary;
        }
    }

    &__btnGroup {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        :global {
            .el-button {
                width: 100%;
                margin-bottom: 14px;
                margin-left: 0;
            }
        }
    }
}
</style>
